module.exports = __webpack_public_path__ + "static/media/ethics-in-tech-gayuru.4b33d3e8.jpeg";